export const CommunitiesHelpers = {
    getStripedClassName : index => {
        return index % 2
             ? 'ant-table-even-row-stripe'
             : 'ant-table-odd-row-stripe';
    }
};